import { app } from '@microsoft/teams-js';
import { endAndReportPerformanceMeasure, startPerformanceMeasure } from '@ms/yammer-data/dist/telemetry';

type IsAppInitialized = () => boolean;
export const isAppInitialized: IsAppInitialized = () => app.isInitialized();

type EnsureInitializedWithTelemetry = () => Promise<void>;
export const ensureInitializedWithTelemetry: EnsureInitializedWithTelemetry = async () => {
  if (!isAppInitialized()) {
    let endedWithError = false;
    const measure = startPerformanceMeasure('meta_os_hub_initialize');

    try {
      await app.initialize();
    } catch (error) {
      endedWithError = true;
    } finally {
      endAndReportPerformanceMeasure({ ...measure, eventProperties: { ...measure.eventProperties, endedWithError } });
    }
  }
};
